import { LokaliseFallback } from './LokaliseFallback';

export default LokaliseFallback;
